import React, { useRef, useState } from "react";
import "./contact.scss"
import emailjs from '@emailjs/browser';


export default function Contact(){
    const form = useRef();
    const [formError, setFormError] = useState('');
    const [fromSuccess, setFormSuccess] = useState(false);

    const sendEmail = (e) => {
      e.preventDefault();
      emailjs
        .sendForm('service_ob18zfe', 'template_57jxxiu', form.current, {
          publicKey: 'AeRapYNhIXaY6m2Oe',
        })
        .then(
          () => {
            form.current?.reset();
            setFormSuccess(true);
            setTimeout(() => {
                setFormSuccess(false);
              }, 5000);

          },
          (error) => {
            setFormError("Message send failed")
            setTimeout(() => {
                setFormError('');
              }, 5000);
          },
        );
    };


    return(
    <div className="contact-container contact">
        <div className="container">
        <div className="heading">
            Contact <span>Me</span>
        </div>
      <form ref={form} onSubmit={sendEmail}>
      <input
          type="text"
          name="user_name"
          placeholder="Name"
          className="input"
          required
        />

        <input
          type="email"
          name="user_email"
          placeholder="Email"
          className="input"
          required
        />

        <textarea
          name="message"
          placeholder="Message"
          className="input"
          required
        />
        <div className="message-div">
          {formError && <p  className="message" style={{ color: 'red' }}>{formError}</p>}
          {fromSuccess && <p className="message" style={{ color: '#52bf52' }}>Message Send Successfully!</p>} </div>
      <input type="submit"  className="custom-button form-btn" value="Send Message" />
    </form>  </div> 
        </div>
    )

}